<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Change"
      back-button-text="Previous"
      class="mb-3"
      @on-complete="formSubmitted"
    >
      <!-- accoint details tab -->
      <tab-content
        title="Change password"
        icon="feather icon-file-text"
        :before-change="onSubmit"
      >
        <validation-observer ref="accountRules" tag="form">
          <b-row class="justify-content-md-center">
            <b-col md="6">
              <b-form-group label="Old Password *" label-for="Old Password">
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                  vid="Password"
                  name="oldPasword"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="Pasword"
                      v-model="requestData.oldPassword"
                      :type="password0FieldType"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password0ToggleIcon"
                        @click="togglePassword0Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!--New Password -->
          <b-row class="justify-content-md-center">
            <b-col md="6">
              <b-form-group label="New Password *" label-for="New Password">
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="Password"
                  rules="required|password"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="Pasword"
                      v-model="requestData.newPassword"
                      :type="password1FieldType"
                      placeholder="New Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password1ToggleIcon"
                        @click="togglePassword1Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Confirm Password -->
          <b-row class="justify-content-md-center">
            <b-col md="6">
              <b-form-group
                label="Confirm Password *"
                label-for="Confirm Password"
              >
                <validation-provider
                  #default="{ errors }"
                  rules="required|confirmed:Password"
                  name="ConfirmPassword "
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="Confirm Password "
                      v-model="requestData.confirmPassword"
                      :type="password2FieldType"
                      placeholder="Confirm Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password2ToggleIcon"
                        @click="togglePassword2Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { initialAbility } from "@/libs/acl/config";
// eslint-disable-next-line no-unused-vars
import { required } from "@validations";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import axios from "@axios";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BOverlay,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";

export default {
  name: "AddAdvancePayment",
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BOverlay,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      required,
      password0FieldType: "password",
      password1FieldType: "password",
      password2FieldType: "password",
      isLoading: false,
      requestData: {
        username: "",
        oldPassword: "",
        newPassword: "",
      },
    };
  },
  computed: {
    password0ToggleIcon() {
      return this.password0FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password1ToggleIcon() {
      return this.password1FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password2ToggleIcon() {
      return this.password2FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  created() {
    axios
      .get(`User/api/V1.0/Account/GetCompaniesByUserId`)
      .then((res) => {
        console.log(res);
        this.requestData.username = res.user.username;
      })
      .catch((res) => {
        this.isLoading = false;
        console.log(res);
      });
  },
  methods: {
    formSubmitted() {
      this.$refs.accountRules.reset();
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Data Submitted",
          icon: "EditIcon",
          variant: "success",
        },
      });
    },
    onSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then((success) => {
          if (success) {
            this.isLoading = true;
            axios
              .post("/User/api/V1.0/Password/ChangePassword", this.requestData)
              .then((res) => {
                if (res.status) {
                  this.isLoading = false;
                  this.$store.dispatch("permission/handleLogout");
                  // Reset ability
                  this.$ability.update(initialAbility);
                  // Redirect to login page
                  this.$router.push({ name: "auth-login" });
                  resolve(true);
                }
              })
              .catch((res) => {
                if (res.status === 400) {
                  this.isLoading = false;
                  reject(res);
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Error",
                      icon: "BellIcon",
                      variant: "danger",
                      text: `${res.data.errors.NewPassword[0]}`,
                    },
                  });
                } else {
                  this.isLoading = false;
                  reject(res);
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Error",
                      icon: "BellIcon",
                      variant: "danger",
                      text: `${res.data.message}`,
                    },
                  });
                }
              });
          } else {
            reject();
          }
        });
      });
    },
    togglePassword0Visibility() {
      this.password0FieldType =
        this.password0FieldType === "password" ? "text" : "password";
    },
    togglePassword1Visibility() {
      this.password1FieldType =
        this.password1FieldType === "password" ? "text" : "password";
    },
    togglePassword2Visibility() {
      this.password2FieldType =
        this.password2FieldType === "password" ? "text" : "password";
    },
  },
};
extend("password", {
  message:
    "{_field_} must be at least 12 characters containing Uppercase, lowercase, Special character i.e (! @ # $ % ^ & *) and number.",
  validate: (value) => {
    const strong_password = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{12,})",
    ); // regex to check our strong password

    return strong_password.test(value); //Test the regex. Test function returns a true or false value.
  },
});
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
